import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'components/Dropdown/Dropdown';
import Datetime from 'react-datetime';
import Moment from 'moment';
import moment from 'moment-timezone';
import './style.scss';
import { AppSettings } from '../../constants';

/*
 *https://github.com/Adphorus/react-date-range
 */

const setToCurrentTime = value => {
  return value.set({
    hour: Moment().hour(),
    minute: Moment().minute(),
    second: Moment().second()
  });
};

export class CustomDateRange extends Component {
  static propTypes = {
    className: PropTypes.string,
    onSave: PropTypes.func,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    optionType: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.options = [
      { key: 0, value: 'Today' },
      { key: 1, value: 'Yesterday' },
      { key: 2, value: 'Last 7 days' },
      { key: 3, value: 'Last 30 days' },
      { key: 4, value: 'Custom range' }
    ];

    this.initialValue = null;

    if (props.startDate && props.endDate) {
      this.options[4] = {
        key: 4,
        value: 'Custom range',
        label:
          Moment(props.startDate).format('MM/DD/YYYY') +
          ' - ' +
          Moment(props.endDate).format('MM/DD/YYYY')
      };
      this.initialValue = this.options[4];
    }

    if (props.optionType) {
      this.initialValue = this.options.find(x => x.value === props.optionType);
    }

    this.state = {
      value: this.initialValue,
      valueStartDate: null,
      valueEndDate: null,
      fromDate: props.startDate ? Moment(props.startDate) : null,
      toDate: props.endDate ? Moment(props.endDate) : null,
      options: this.options,
      isDisplayPopupCustomValue: false,
      isOpenFromDate: true,
      error: null
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleHideDateRange);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isKeepShow: false,
      isDisplayPopupCustomValue: false
    });

    if (
      nextProps.startDate !== this.props.startDate ||
      nextProps.endDate !== this.props.endDate
    ) {
      const newOptions = [...this.state.options];
      newOptions[4].label =
        Moment(nextProps.startDate).format('MM/DD/YYYY') +
        ' - ' +
        Moment(nextProps.endDate).format('MM/DD/YYYY');

      let newValue = null;

      if (nextProps.endDate) {
        newValue = nextProps.optionType
          ? newOptions.find(x => x.value === nextProps.optionType)
          : newOptions[4];
      }
      this.setState({
        fromDate: nextProps.startDate ? Moment(nextProps.startDate) : null,
        toDate: nextProps.endDate ? Moment(nextProps.endDate) : null,
        options: nextProps.endDate ? newOptions : this.options,
        value: newValue
      });
    }
  }

  componentDidUpdate() {
    // if (this.state.isDisplayPopupCustomValue) {
    //   const offsetElement = this.customRange.getBoundingClientRect();
    //   if (offsetElement.left + offsetElement.width > document.documentElement.clientWidth - 30) {
    //     let className = this.customRange.getAttribute('class');
    //     className += ' responsive';
    //     this.customRange.setAttribute('class', className);
    //   } else {
    //     let className = this.customRange.getAttribute('class');
    //     className.replace('responsive', '');
    //     this.customRange.setAttribute('class', className);
    //   }
    // }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleHideDateRange);
  }

  callbackSelectDate = key => {
    let startDate = null;
    let endDate = null;
    if (key === 0) {
      //today
      startDate = moment
        .tz(Moment(), AppSettings.TIMEZONE)
        .set({ hour: 0, minute: 0, second: 0 })
        .format();
      endDate = moment
        .tz(Moment(), AppSettings.TIMEZONE)
        .set({ hour: 23, minute: 59, second: 59 })
        .format();
    } else if (key === 1) {
      //yesterday
      startDate = moment
        .tz(Moment().add(-1, 'days'), AppSettings.TIMEZONE)
        .set({ hour: 0, minute: 0, second: 0 })
        .format();
      endDate = moment
        .tz(Moment().add(-1, 'days'), AppSettings.TIMEZONE)
        .set({ hour: 23, minute: 59, second: 59 })
        .format();
    } else if (key === 2) {
      //last 7 days
      // startDate = moment
      //   .tz(Moment().add(-1, 'weeks'), AppSettings.TIMEZONE)
      //   .set({ hour: 0, minute: 0, second: 0 })
      //   .format();
      // endDate = moment
      //   .tz(Moment(), AppSettings.TIMEZONE)
      //   .set({ hour: 23, minute: 59, second: 59 })
      //   .format();
        startDate =  moment
        .tz(Moment().add(-1, 'weeks'), AppSettings.TIMEZONE)
        .utcOffset(AppSettings.TIMEZONE) 
        .format();
        endDate = moment.tz(Moment().subtract(1, 'days'), AppSettings.TIMEZONE)
        .utcOffset(AppSettings.TIMEZONE) 
        .format();
    } else if (key === 3) {
      //last 30 days
      startDate = moment
        .tz(Moment().add(-1, 'months'), AppSettings.TIMEZONE)
        .utcOffset(AppSettings.TIMEZONE) 
        .format();
      endDate = moment.tz(Moment().subtract(1, 'days'), AppSettings.TIMEZONE)
      .utcOffset(AppSettings.TIMEZONE) 
      .format();
    }

    this.props.onSave(startDate, endDate, this.state.value);
  };

  onSelectChange = e => {
    this.setState(
      {
        value: e.value,
        fromDate: null,
        toDate: null,
        error: null
      },
      () => {
        this.callbackSelectDate(e.value ? e.value.key : null);
      }
    );
  };

  onHoverValueCustom = () => {
    const offsetElement = this.customRange.getBoundingClientRect();

    if (
      offsetElement.left + offsetElement.width >
      document.documentElement.clientWidth - 30
    ) {
      let className = this.customRange.getAttribute('class');
      className += ' responsive';
      this.customRange.setAttribute('class', className);
    } else {
      let className = this.customRange.getAttribute('class');
      className.replace('responsive', '');
      this.customRange.setAttribute('class', className);
    }

    this.setState({
      isKeepShow: true,
      isDisplayPopupCustomValue: true
    });
  };

  handleHideDateRange = event => {
    if (this.state.isDisplayPopupCustomValue) {
      if (!this.customRange.contains(event.target)) {
        this.setState({
          isKeepShow: false,
          isDisplayPopupCustomValue: false,
          error: null
        });
        if (
          !this.state.value ||
          (this.state.value &&
            this.state.value.key !== 4 &&
            this.state.valueStartDate &&
            this.state.valueEndDate)
        ) {
          this.setState({
            fromDate: null,
            toDate: null
          });
        }
      } else {
        this.setState({
          isKeepShow: true
        });
      }
    }
  };

  onSetValue = () => {
    const stateFromDate = this.state.fromDate;
    const stateToDate = this.state.toDate;
    if (Moment(stateToDate).diff(Moment(stateFromDate), 'days') >= 0) {
      this.setState({
        error: null,
        isKeepShow: false
      });
      const startDate = Moment(stateFromDate).format('MM/DD/YYYY');
      const endDate = Moment(stateToDate).format('MM/DD/YYYY');
      const customCoeOptions = [...this.state.options];
      customCoeOptions.pop();
      customCoeOptions.push({
        key: 4,
        value: 'Custom range',
        label: startDate + ' - ' + endDate
      });
      this.setState(
        {
          options: customCoeOptions,
          value: this.state.options[4],
          isDisplayPopupCustomValue: false,
          isKeepShow: false,
        //   valueStartDate: moment
        //   .tz(setToCurrentTime(Moment(stateFromDate)), AppSettings.TIMEZONE)
        //   .set({ hour: 0, minute: 0, second: 0 })
        //   .format(),
        // valueEndDate: moment
        //   .tz(setToCurrentTime(Moment(stateToDate)), AppSettings.TIMEZONE)
        //   .set({ hour: 23, minute: 59, second: 59 })
        //   .format(),
        valueStartDate: moment(stateFromDate)
        .startOf('day') 
        .utcOffset(AppSettings.TIMEZONE) 
        .format(),
        valueEndDate: moment(stateToDate)
        .startOf('day') 
        .utcOffset(AppSettings.TIMEZONE)
        .format()
        },
        () => {
          this.props.onSave(
            this.state.valueStartDate,
            this.state.valueEndDate,
            this.state.value
          );
        }
      );
    } else {
      this.setState({
        error: '"To" must be greater than "From".'
      });
    }
  };

  onReset = () => {
    this.setState(
      {
        value: null
      },
      () => {
        this.callbackSelectDate(null);
      }
    );
  };

  customRenderDate = item => {
    if (item.key === 4) {
      return item.label;
    } else {
      return item.value;
    }
  };

  customRenderItem = item => {
    if (item.key === 4) {
      return (
        <div
          className='custom-item'
          ref={ref => {
            this.customItem = ref;
          }}
        >
          {item.value}
          <i
            className='pe-7s-angle-right'
            style={{
              fontSize: 35,
              position: 'absolute',
              right: 0,
              top: '-45%'
            }}
          />

          <div
            className='custom-range-date box-form-siteone'
            ref={ref => {
              this.customRange = ref;
            }}
            style={
              this.state.isDisplayPopupCustomValue
                ? null
                : { visibility: 'hidden' }
            }
          >
            <div className='col-sm-6 no-padding' style={{ marginTop: 20 }}>
              <div
                className='custom-group form-group col-sm-12 no-padding'
                style={{ marginBottom: 10 }}
              >
                <label className='col-sm-3 no-padding'>From</label>
                <Datetime
                  key={'fromDate' + this.state.fromDate}
                  className='col-sm-9 custom-input'
                  ref={ref => {
                    this.fromDate = ref;
                  }}
                  inputProps={{ placeholder: 'mm/dd/yyyy', autoFocus: true }}
                  value={this.state.fromDate}
                  open={this.state.isDisplayPopupCustomValue}
                  timeFormat={false}
                  onChange={fromDate => {
                    this.setState({ fromDate });
                  }}
                  />
              </div>
              <div
                className='custom-group form-group col-sm-12 no-padding'
                style={{ marginBottom: 10 }}
              >
                <label className='col-sm-3 no-padding'>To</label>
                <Datetime
                  key={'toDate' + this.state.toDate}
                  className='col-sm-9 custom-input custom-input-to'
                  ref={ref => {
                    this.toDate = ref;
                  }}
                  inputProps={{ placeholder: 'mm/dd/yyyy' }}
                  value={this.state.toDate}
                  timeFormat={false}
                  onChange={toDate => {
                    this.setState({ toDate: toDate });
                  }}
                  />
              </div>
              {this.state.error && (
                <div className='custom-group form-group col-sm-12 no-padding'>
                  <span
                    className='col-sm-12 no-padding text-danger'
                    style={{ wordBreak: 'break-all' }}
                  >
                    {this.state.error}
                  </span>
                </div>
              )}
              <div
                className='custom-group col-sm-12 no-padding'
                style={{ marginTop: 10 }}
              >
                <button
                  className='btn btn-primary btn-siteone'
                  disabled={!this.state.fromDate || !this.state.toDate}
                  onClick={this.onSetValue}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return item.value;
    }
  };

  render() {
    return (
      <div className='custom-date-range'>
        <div className={this.props.className} style={{ padding: 0 }}>
          <Dropdown
            onChange={this.onSelectChange}
            className='filestring-dropdown filter-dropdown'
            options={this.state.options}
            optionLabel='value'
            value={this.state.value}
            onHoverValue={4}
            onHoverLabel='key'
            onHoverItem={this.onHoverValueCustom}
            showClear={true}
            isKeepShow={this.state.isKeepShow}
            labelTemplate={this.customRenderDate}
            itemTemplate={this.customRenderItem}
            placeholder='Any time'
            style={{ width: '100%' }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/date-range/index.js